var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sweet-modal',{ref:"welcomeModal",attrs:{"overlay-theme":"dark","width":"1200px"}},[_c('a',{staticClass:"sweet-box-link",attrs:{"href":"http://www.weterynariaprzyszlosci.pl","target":"_blank"}},[_vm._v("Odwiedź stronę »")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e671f5aa","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/WelcomeModal.vue
// module id = null
// module chunks = 